import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X, Download } from "lucide-react";

const DISMISS_KEY = "yp_pwa_dismissed";
const isStandalone = () =>
  (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;
const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const iosInfo = () => {
  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isChrome = /CriOS/i.test(ua);
  return { isIOS, isChrome };
};

// Invito installazione PWA: solo mobile, mai in standalone, chiudibile e "non mostrare più".
// iOS: nessun prompt nativo simulato → guida per Safari/Chrome basata sul browser reale.
export function InstallPrompt() {
  const { t } = useTranslation();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosGuide, setIosGuide] = useState(false);
  const { isIOS, isChrome } = iosInfo();

  useEffect(() => {
    if (!isMobile() || isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBIP);
    if (isIOS) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onBIP);
  }, []); // eslint-disable-line

  if (!show) return null;
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (deferred) { deferred.prompt(); try { await deferred.userChoice; } catch (e) {} setDeferred(null); setShow(false); }
    else setIosGuide(true);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9990] p-3 sm:hidden" data-testid="pwa-install-banner">
      <div className="yp-card p-4 shadow-xl border border-slate-200 bg-white">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="font-semibold">{t("pwa.title")}</div>
            <div className="text-xs text-slate-500 mt-1">{t("pwa.desc")}</div>
          </div>
          <button onClick={dismiss} className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full hover:bg-slate-100" aria-label="X" data-testid="pwa-dismiss"><X className="w-5 h-5" /></button>
        </div>
        {!iosGuide && (
          <button onClick={install} className="yp-btn yp-btn-primary w-full mt-3 !py-2 text-sm inline-flex items-center justify-center gap-2" data-testid="pwa-install-btn">
            <Download className="w-4 h-4" />{deferred ? t("pwa.install") : t("pwa.how")}
          </button>)}
        {iosGuide && (
          <ol className="text-sm text-slate-600 mt-3 list-decimal pl-5 space-y-1" data-testid="pwa-ios-steps">
            <li>{t(isChrome ? "pwa.ios_open_chrome" : "pwa.ios_open_safari")}</li>
            <li>{t("pwa.ios_share")}</li>
            <li>{t("pwa.ios_add")}</li>
            <li>{t("pwa.ios_confirm")}</li>
          </ol>)}
      </div>
    </div>);
}
